import { BG_SCHEMA, BUTTON_SCHEMA, TEXT_SCHEMA, TITLE_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const CONTENT_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'content',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    bg: BG_SCHEMA(),
    'button-alignment': 'left',
    buttons: [BUTTON_SCHEMA()],
    media: {alignment: 'left', type: '', content: '', videoid: ''},
    title: TITLE_SCHEMA('Conteúdo', 'center'),
    text: TEXT_SCHEMA('Texto informativo', 'center'),
    'text-position': 'center',
    'text-position-vertical': 'center',
  }
}

export const beforeParseContent = target => {
  commonBeforeParseMethod(target)
  if (target.text && !Object.hasOwn(target.text, 'alignment')) {
    Object.assign(target, {text: {...target.text, alignment: target['text-position'] === 'center' ? 'center' : 'left'}})
  }
  
  if (target.title && !Object.hasOwn(target.title, 'alignment')) {
    Object.assign(target, {title: {...target.title, alignment: target['text-position'] === 'center' ? 'center' : 'left'}})
  }

  if (target.media && !Object.hasOwn(target.media, 'alignment')) {
    Object.assign(target, {media: {...target.media, alignment: target['text-position'] || 'right'}})
    Object.assign(target, {'text-position': 'center'})
  }
}

export const CONTENT_SECTION = config => ({
  schema: CONTENT_SCHEMA(config),
  beforeParse: beforeParseContent
})
